import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer  } from '@angular/platform-browser';
import { AccountServiceProvider } from '../../providers/account-service/account-service';
import { Shareddata } from '../../providers/shareddata';
import { FuncsService } from '../../services/funcs.services';
import smoothscroll from 'smoothscroll-polyfill';

@Component({
	selector      : 'app-page',
	templateUrl   : './page.component.html',
	encapsulation : ViewEncapsulation.None,
	host: {
		'(window:resize)': 'onResize($event)'
	}
})

export class PageComponent implements OnInit {
	public result        : any;
	public selectedtab   : any;
	public scroll_to     : any;
	public error_message : any;
	public breadcrumb_child_length : number;
	public params_offset           : number;
	public i                       : number;
	public tab                    : any = [];
	public tab_content            : any = [];	
	public intro                  : any = [];
	public right_col_content      : any = [];
	public breadcrumb             : any = [];	
	public news                   : any = [];
	public news_limit             : any = [];	
	public news_data              : any = [];	
	public convenor               : any = [];
	public convenor_data          : any = [];
	public photos_videos          : any = [];
	public flickr_data            : any = [];
	public youtube_data           : any = [];
	public vimeo_data             : any = [];
	public inquiry                : any = [];
	public register               : any = [];
	public engage                 : any = [];
	public engage_data            : any = [];
	public community              : any = [];
	public community_parent       : any = [];
	public content_pages          : any = [];
	public content_pages_selected : any = [];
	public sponsor_info           : any = [];
	public content                : any = [];
	public form_content           : any = [];
	public speaker                : any = [];
	public faq_block_title        : any = [];
	public faq_repeater           : any = [];
	public dform_content          : any = [];
	public blurb_block_color      : any = [];
	public blurb_repeater         : any = [];
	public sibling_block_title    : any = [];
	public sibling                : any = [];
	public newsletter_data        : any = [];
	public fact_data              : any = [];
	public quote_data             : any = [];
	public double_content_data    : any = [];
	public file_data              : any = [];
	public home_banner_data       : any = [];
	public home_banner_class      : any = [];
	public home_banner_image      : any = [];
	public home_news_data         : any = [];
	public wp_engage_data         : any = [];
	public accordion_data         : any = [];
	public loadButton         : boolean = true;	
	public error_message_show : boolean = false;
	public need_login_view    : boolean = false;
	public isMobile           : boolean;

	constructor(
		private router         : Router,
		private sanitizer      : DomSanitizer,
		private accountService : AccountServiceProvider,
		public shareddata      : Shareddata,
		private funcs          : FuncsService,		
	) {
		smoothscroll.polyfill();
		this.isMobile = this.funcs.globalDetectDevice();
		/* routing */
		this.router.routeReuseStrategy.shouldReuseRoute = function () {
      		return false; 
    	};
    	/* routing */
		let current_url = this.router.url;
		/** manual redirection */
		if ( '/about-this-website/processing-personal-data' == current_url ) {
			window.location.href = 'https://www.worldwaterweek.org/terms-of-use';
			return;
		} else if ( '/general-information/translation-services' == current_url ) {
			window.location.href = 'https://worldwaterweek.org/convenors-success-programme/general-information/translation-services';
			return;
		} else if ( '/general-information' == current_url ) {
			window.location.href = 'https://worldwaterweek.org/convenors-success-programme/general-information';
			return;
		} else if ( '/exhibitions' == current_url ) {
			window.location.href = 'https://worldwaterweek.org/convenors-success-programme/exhibitions';
			return;
		} else if ( '/programme/schedule' == current_url ) {
			window.location.href = 'https://trippus.net/worldwaterweek2024';
			return;
		}
		/** manual redirection */
		if ( this.router.url.includes( 'community' ) )
			setTimeout ( () => {
				this.loadButton = false;
			}, 1000 );

		let params = {
			"slug" : current_url,
		};
		var id;
		id = 0;
		let pageparams = {
			"slug" : current_url,
			"id" : id,
		}
		this.accountService.getInnerPageData( pageparams ).then( ( result: any ) => {
			if ( 'Ok' === result.status ) {
				if ( '404' != result.type ) {
					if ( 'yes' == result.need_login ) {
						if ( 'userData' in window.localStorage )
							this.pageData( result, params );
						else {
							sessionStorage.setItem( 'isPageNeedLogin', JSON.stringify( 1 ) );
							this.need_login_view = true;
							this.goToLoginPage();
							this.loadButton = false;
						}
					} else
						this.pageData( result, params );					
				} else
					this.funcs.globalNavigate( '/404' );

				sessionStorage.setItem( 'currentPageUrl', JSON.stringify( { prev_url : current_url } ) );
				sessionStorage.setItem( 'currentPageID', JSON.stringify( 0 ) );
			}  else {
				this.error_message_show = true;
				if ( '3111' == result.errcode ) {
					this.error_message = 'Oops, looks like something went wrong!';
				} else {
					this.error_message = result.message;
				}
				setTimeout ( () => {
					this.loadButton = false;
				}, 1000 );
			}
		});	
	}

	@HostListener('window:popstate', ['$event'])
	onPopState(event) {
		location.reload();
	}

	pageData( result, params ) {
		sessionStorage.setItem( 'isPageNeedLogin', JSON.stringify( 0 ) );
		this.need_login_view = false;
		let response_intro_content;
		response_intro_content = result.intro_content ? result.intro_content.replace(/<\/?[^>]+(>|$)/g, "") : '';
		let intro_content = result.intro_content;
		if ( null != intro_content ) {
			intro_content = intro_content.toString();
			intro_content = intro_content.replace( /(<([^>]+)>)/ig, '');
		}
		let scroll_to_tab = 0;
		this.result              = result.components;
		this.i                   = 0;
		this.intro['heading']    = result.headline;
		this.intro['content']    = this.sanitizer.bypassSecurityTrustHtml( result.intro_content );
		this.right_col_content   = result.right_col_content;
		if ( result.seo_data ) {
			let alternateTitle = result.headline;
			this.funcs.globalSeoData( result, alternateTitle );
		}
		if ( this.result != null ) {
			if ( result.components ) {
				for ( let entry of result.components ) {
					if ( 'yes' === entry.is_tab_page_content ) {
						this.breadcrumb_child_length = 1;
						scroll_to_tab = 1;
						this.tab[ this.i ] = entry.data;
						this.selectedtab   = entry.slug;
						this.tab_content[ this.i ]    = entry.data;
					} else {
						if ( 'tab_block' === entry.acf_fc_layout ) {
							this.tab[ this.i ] = entry.data;
							this.selectedtab   = entry.data[0].slug;
							this.tab_content[ this.i ] = entry.data;
						}
					}
					if ( 'news_block' === entry.acf_fc_layout ) {
						this.news[ this.i ]       = entry;
						this.news_limit[ this.i ] = entry.nb_limit;
						this.news_data = entry.data;
					}
					if ( 'convenor_block' === entry.acf_fc_layout ) {
						this.convenor[ this.i ] = entry;
						let convenor_params = {
							'offset' : 0,
						};
						this.accountService.getConvenorPressRelease( convenor_params ).then( ( dotnetresponse: any ) => {
							if ( dotnetresponse.status == 'Ok' ) {
								this.convenor_data = dotnetresponse.pressReleases;
								this.params_offset = convenor_params.offset;
							}
						});
					}
					if ( 'photos_&_videos_block' === entry.acf_fc_layout ) {
						this.photos_videos[ this.i ] = entry;
						if ( '' != entry.channel_source ) {
							for ( let ctype of entry.channel_source ) {
								if ( 'flickr' === ctype.channel_type )
									this.flickr_data = ctype;
								if ( 'youtube' === ctype.channel_type )
									this.youtube_data = ctype;
								if ( 'vimeo' === ctype.channel_type )
									this.vimeo_data = ctype;
							}
						}
					}
					if ( 'inquiry_block' === entry.acf_fc_layout )
						this.inquiry[ this.i ] = entry;
					if ( 'register_block' === entry.acf_fc_layout )
						this.register[ this.i ] = entry;
					if ( 'engage_block' === entry.acf_fc_layout ) {
						this.engage[ this.i ] = entry;
						this.engage_data[ this.i ] = entry.dotnetprogrammes;
					}
					/*if( 'community_block' === entry.acf_fc_layout ) {
						this.community[ this.i ] = entry;
						this.content_pages[ this.i ] = entry.content_pages;
						this.content_pages_selected[ this.i ] = entry.selected_tab;
						this.sponsor_info[ this.i ] = entry.sponsor_info;
					}
					if ( 'convening_organisation_block' == entry.acf_fc_layout ) {
						this.community[ this.i ] = entry;
						this.community_parent[ this.i ] = '';
						this.content_pages[ this.i ] = '';
						this.content_pages_selected[ this.i ] = '';
						this.sponsor_info[ this.i ] = '';
					}*/
					if ( 'simple_content_block' === entry.acf_fc_layout ) {
						this.content[ this.i ] = entry;
					}
					if ( 'form_block' === entry.acf_fc_layout )
						this.form_content[ this.i ] = entry;
					if ( 'speaker_block' === entry.acf_fc_layout )
						this.speaker[ this.i ] = entry;
					if ( 'faq_block' === entry.acf_fc_layout ) {
						this.faq_block_title[ this.i ] = entry.inner_faq_block_title;
						this.faq_repeater[ this.i ] = entry.inner_faq;
						this.faq_repeater[this.i].forEach( ( v, i ) => {
							this.faq_repeater[this.i][i].inner_answer = this.sanitizer.bypassSecurityTrustHtml( v.inner_answer );
						});
					}					
					if ( 'blurb_block' === entry.acf_fc_layout ) {
						this.blurb_repeater[ this.i ] = entry.inner_blurb;
						this.blurb_block_color[ this.i ] = entry.blurb_block_color;
					}
					if ( 'sibling_block' === entry.acf_fc_layout ) {
						this.sibling_block_title[ this.i ] = entry.page_title;
						this.sibling[ this.i ] = entry.choose_data;
					}
					if ( 'dynamic_form_block' === entry.acf_fc_layout ) {
						this.dform_content[ this.i ] = entry;
					}
					if ( 'newsletter_block' == entry.acf_fc_layout ) {
						this.newsletter_data[ this.i ] = entry;
					}
					if ( 'fact_block' == entry.acf_fc_layout ) {
						this.fact_data[ this.i ] = entry;
						this.fact_data[ this.i ].fact_content = this.sanitizer.bypassSecurityTrustHtml( entry.fact_content );
						this.fact_data[ this.i ].left_col_fact_content = this.sanitizer.bypassSecurityTrustHtml( entry.left_col_fact_content );
						this.fact_data[ this.i ].right_col_fact_content = this.sanitizer.bypassSecurityTrustHtml( entry.right_col_fact_content );
					}
					if ( 'quote_block' == entry.acf_fc_layout ) {
						this.quote_data[ this.i ] = entry;
					}
					if ( 'double_content_column' == entry.acf_fc_layout ) {
						this.double_content_data[ this.i ] = entry;
						this.double_content_data[ this.i ].double_content_repeater.forEach( ( v, i ) => {
							this.double_content_data[ this.i ].double_content_repeater[i].double_content_description = this.sanitizer.bypassSecurityTrustHtml( v.double_content_description );
						});
					}
					if ( 'file_block' == entry.acf_fc_layout ) {
						this.file_data[ this.i ] = entry;
					}
					if ( 'home_banner_block' == entry.acf_fc_layout ) {
						let banner_type = entry.banner_type;
						if ( 'image' == banner_type ) {
							this.home_banner_class[ this.i ] = ' banner-image';
							this.home_banner_image[ this.i ] = entry.home_banner_image;
						} else if( 'animation' == banner_type ) {
							this.home_banner_class[ this.i ] = ' banner-image banner-image-animation';
							this.home_banner_image[ this.i ] = entry.animation_upload_image;
						} else if ( 'video' == entry.banner_type ) {
							this.home_banner_class[ this.i ] = ' banner-video';
							entry.banner_video_linka = this.sanitizer.bypassSecurityTrustHtml( entry.banner_video_linka );
							if ( '' != entry.banner_video_linka_mobile ) {
								entry.banner_video_linka_mobile = this.sanitizer.bypassSecurityTrustHtml( entry.banner_video_linka_mobile );
							} else {
								entry.banner_video_linka_mobile = entry.banner_video_linka;
							}
						} else if ( 'scripted' == entry.banner_type ) {
							this.home_banner_class[ this.i ] = ' banner-video scripted-iframe-banner';
							entry.banner_scripted_iframe = this.sanitizer.bypassSecurityTrustHtml( entry.banner_scripted_iframe );
							if ( '' != entry.banner_scripted_iframe_mobile ) {
								entry.banner_scripted_iframe_mobile = this.sanitizer.bypassSecurityTrustHtml( entry.banner_scripted_iframe_mobile );
							} else {
								entry.banner_scripted_iframe_mobile = entry.banner_scripted_iframe;
							}
						} else if ( 'mov' == entry.banner_type ) {
							this.home_banner_class[ this.i ] = ' banner-mov';
						} else if ( 'facebook' == entry.banner_type ) {
							this.home_banner_class[ this.i ] = ' banner-video facebook-banner-embed';
							entry.facebook_video_link = this.sanitizer.bypassSecurityTrustResourceUrl( 'https://www.facebook.com/plugins/video.php?href=' + entry.facebook_video_link  + '&show_text=false&t=0' );
							if ( '' != entry.facebook_video_link_mobile ) {
								entry.facebook_video_link_mobile = this.sanitizer.bypassSecurityTrustResourceUrl( 'https://www.facebook.com/plugins/video.php?href=' + entry.facebook_video_link_mobile  + '&show_text=false&t=0' );
							} else {
								entry.facebook_video_link_mobile = entry.facebook_video_link;
							}
						}
						this.home_banner_data[ this.i ] = entry;
					}
					if ( 'home_news' == entry.acf_fc_layout ) {
						this.home_news_data[ this.i ] = entry;
					}
					if ( 'wp_engage_block' == entry.acf_fc_layout ) {
						this.wp_engage_data[ this.i ] = entry;
					}
					if ( 'accordion_block' == entry.acf_fc_layout ) {
						this.accordion_data[ this.i ] = entry;
					}
					if ( 'tab_block' == entry.acf_fc_layout ) {
						this.tab[ this.i ] = entry.data;
						if ( '' == this.selectedtab ) {
							this.selectedtab   = entry.data[0].slug;
						}
						this.tab_content[ this.i ] = entry.data;
						this.tab_content[ this.i ].forEach( ( val ) => {
							if ( '' != val.block_data ) {
								val.block_data.forEach( ( value ) => {
									if ( 'imagevideo_block' == value.acf_fc_layout ) {
										if ( 'video' == value.media_type ) {
											value.media_video_repeater.forEach( ( vid ) => {
												vid.iv_video_url = this.sanitizer.bypassSecurityTrustHtml( vid.iv_video_url );
											})
										}
									}
								})								
							}
						});
					}
					this.i++;
				}
			}
			if ( 'yes' == result.scrollable ) {
				this.scroll_to = 'app-' + result.scrollto;
				setTimeout( () => {
					const scrollElement = document.getElementById( this.scroll_to );
					const yCoordinate = scrollElement.getBoundingClientRect().top + window.pageYOffset;
					let yOffset;
					if( this.isMobile )
						yOffset = -60;
					else
						yOffset = 0;
					window.scrollTo({
						top: yCoordinate + yOffset,
						behavior: 'smooth'
					});
				}, 3000 );
			} else {
				if ( scroll_to_tab == 1 ) {
					setTimeout( () => {
						const scrollElement = document.getElementById( 'app-tab_block' );
						const yCoordinate = scrollElement.getBoundingClientRect().top + window.pageYOffset;
						let yOffset;
						if( this.isMobile )
							yOffset = -60;
						else
							yOffset = 0;
						window.scrollTo({
							top: yCoordinate + yOffset,
							behavior: 'smooth'
						});
					}, 3000 );
				}
				this.scroll_to = 'app-0';
			}
		}
		this.loadButton = false;
		this.accountService.getBreadCrumb( params ).then( ( response: any ) => {
			if ( 'Ok' === response.status ) {
				this.breadcrumb          = response.breadcrumb;
				this.breadcrumb_child_length = response.breadcrumb.children.length;
			}
		});
	}

	ngOnInit() {
		var headerClass = document.getElementsByClassName( 'header');
		if ( ! headerClass[0].classList.contains( 'inner_page_menu' ) )
			headerClass[0].classList.add( 'inner_page_menu' );
	}

	onResize(event) {}

	ngAfterContentInit() {
		setTimeout (
			() => {
				if ( document.querySelector( '#app-register_block' ) )
					document.querySelector( 'body' ).classList.add( 'body-register-page' );
			}, 400
		);
	}

	goToLoginPage() {
		document.getElementById( 'pageaccountclick' ).click();
	}
}